import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type {
  OpalApiResponseDocument,
  OpalApiRequestParams,
} from '../../schema'

type ReadCustomFieldTypes = 'ReadCustomFieldTypesV3'

export async function readCustomFieldTypes(
  params?: OpalApiRequestParams<ReadCustomFieldTypes>
) {
  const url = new URL('/loupe/v3/custom_field_types', window.location.origin)

  url.search = queryString(params?.query)

  return HttpClient()
    .get<OpalApiResponseDocument<ReadCustomFieldTypes, 200>>(url.toString())
    .then((res) => res.data)
}
